"use strict";

var React = require("react"),
    PropTypes = require("prop-types"),
    classnames = require("classnames"),
    Tabs = function Tabs(s) {
  var e = classnames(s.className, {
    "blx-vertical-tabs": s.vertical,
    "blx-horizontal-tabs": !s.vertical,
    "blx-disabled": s.disabled
  }),
      a = React.Children.map(s.children, function (e) {
    return React.cloneElement(e, {
      tabIndex: s.disabled ? "-1" : void 0
    });
  });
  return React.createElement("ul", {
    style: s.style,
    className: e
  }, a);
};

Tabs.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  vertical: PropTypes.bool
}, Tabs.defaultProps = {
  className: "",
  style: null,
  disabled: !1,
  vertical: !1
}, module.exports = Tabs;